module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Are you sure you want to delete the address from the list?","text":"Once deleted, all information about the address will be removed from the system."}}')
  delete Component.options._Ctor
}
